import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Row, Col, Table, Button, Icon } from 'antd'
import _ from 'lodash'
import Detail from './Detail'
import * as style from './style.scss'
import CollectionClinicServicePopup from '@components/Popup/CollectionClinicServicePopup'
import ServiceFieldsNotRelatedClinicPopup from '@components/Popup/ServiceFieldsNotRelatedClinicPopup'

@inject((store: any) => {
    const { popupStore, clinicsStore, clinicServicesStore, collectionsStore } = store
    return { popupStore, clinicsStore, clinicServicesStore, collectionsStore }
})
@observer
class List extends Component<any> {
    handleShowCollectionPopup = id => {
        const { popupStore, collectionsStore } = this.props
        let PER_PAGE = 5
        collectionsStore.getCollectionsByClinic(id, 1, PER_PAGE)
        popupStore.togglePopup('collection_clinicServicesList', { clinic_id: id })
    }

    handleShowServiceFieldPopup = async id => {
        const { popupStore, clinicServicesStore, clinicsStore } = this.props

        await clinicsStore.getClinic(id)
        const { clinic } = clinicsStore

        let clinic_serviceClinicsIds = _.map(clinic.serviceClinics, 'clinic_service_id')

        clinicServicesStore.setFilter('clinic_services_ids', clinic_serviceClinicsIds)

        clinicServicesStore.setFilter('clinic_id', id)

        clinicServicesStore.getClinicServicesList(1)
        clinicServicesStore.getFilteredClinicServicesList()
        popupStore.togglePopup('serviceFieldListPopup', {
            clinic_id: id,
            clinicsPage: clinicsStore.paging.page,
            clinic_services_ids: clinic_serviceClinicsIds
        })
    }
    handlePageChange = page => {
        const { clinicsStore } = this.props
        clinicsStore.changePage(page)
        clinicsStore.getClinics(page)
    }
    render() {
        const { list, paging, loading } = this.props.clinicsStore

        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                align: 'right',
                render: (_, clinic) => <span>{clinic.id}</span>
            },
            {
                title: 'שם מרפאה',
                key: 'name',
                align: 'right',
                render: (_, clinic) => <span>{clinic.name}</span>
            },
            {
                title: 'תחום שירות',
                key: 'serviceClinics',
                align: 'right',
                render: (_, clinic) => {
                    if (clinic.serviceClinics && clinic.serviceClinics.length > 1) {
                        return <Detail serviceClinics={clinic.serviceClinics} />
                    } else {
                        return clinic.serviceClinics && clinic.serviceClinics.length > 0 ? (
                            <span>{clinic.serviceClinics[0].name}</span>
                        ) : (
                            ''
                        )
                    }
                }
            },
            {
                title: 'הוסף תחום שירות',
                key: '',
                width: 50,
                align: 'right',
                render: (_, clinic) => (
                    <Button onClick={() => this.handleShowServiceFieldPopup(clinic.id)}>
                        <span style={{ textDecoration: 'underline' }}>הוסף+</span>
                    </Button>
                )
            },
            {
                title: 'סוג מרפאה',
                key: 'clinicTypesName',
                align: 'right',
                render: (_, clinic) => <span>{clinic.clinicTypesName}</span>
            },
            {
                title: 'שם חברה',
                key: 'companyName',
                align: 'right',
                render: (_, clinic) => <span>{clinic.companyName}</span>
            },
            {
                title: 'כתובת',
                key: 'city',
                align: 'right',
                render: (_, clinic) => (
                    <span>
                        {clinic.street} {clinic.house} {(clinic.street || clinic.house) && ','} {clinic.cityName}
                    </span>
                )
            },
            {
                title: 'טלפון',
                key: 'phone',
                align: 'right',
                render: (_, clinic) => <span>{clinic.phone}</span>
            },
            {
                title: 'זכויות',
                key: 'edit',
                width: 50,
                align: 'right',
                render: (_, clinic) => (
                    <Button onClick={() => this.handleShowCollectionPopup(clinic.id)}>
                        <Icon type="edit" />
                    </Button>
                )
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            columns={columns}
                            rowClassName={() => style.user_row}
                            dataSource={list}
                            pagination={{
                                total: paging.total,
                                pageSize: 10,
                                current: paging.page
                            }}
                            onChange={e => this.handlePageChange(e.current)}
                        />
                    </div>
                    <CollectionClinicServicePopup />
                    <ServiceFieldsNotRelatedClinicPopup />
                </Col>
            </Row>
        )
    }
}

export default withRouter(List)
